import React from "react";
import { useNavigate } from "react-router-dom";
import MainMenuItem from "app/components/MainMenuItem";
import Path from "app/route/Path";

function ContactMenuItem(props) {
  const navigate = useNavigate();

  const onMenuItemClicked = () => {
    navigate(Path.contract.contact.create(0));
  };

  return (
    <MainMenuItem
      itemTitleString="連絡する"
      onClick={onMenuItemClicked}
      size="100%"
    />
  );
}

export default ContactMenuItem;
